import React from 'react';
import { useTranslation } from 'react-i18next';
import CTA from "../../../components/Constant/cta/CTA";
import WhySection from "../../../components/WhySection/WhySection";
import IntroSection from "../../../components/IntroSection/IntroSection";
import FAQList from "../../../components/Constant/FAQCard/FAQCard";
import InfoBlocks from "../../../components/InfoBlocks/InfoBlocks";
import SEO from "../../../utils/SEO";

export default function WesternSaharaJurisdiction() {
    const { t } = useTranslation();
    const tp = (k, d) => t(`pages.western-sahara-jurisdiction.${k}`, d);
    const obj = (k) => tp(k, { returnObjects: true });

    return (
        <main className='main'>
            <SEO
                title={tp('seo.title')}
                description={tp('seo.description')}
                keywords={tp('seo.keywords')}
                url="/western-sahara-jurisdiction"
            />
            <IntroSection
                title={tp('intro.title')}
                subtitle={tp('intro.subtitle')}
                description={tp('intro.description')}
                badges={obj('intro.badges')}
                buttonText={tp('intro.button')}
                buttonLink="/quote"
                imageSrc={require('../../../assets/images/jurisdictions/western-sahara-hero.png')}
                imageAlt={tp('intro.imageAlt')}
            />

            <section className='section'>
                <div className="container">
                    <WhySection
                        title={tp('why.title')}
                        blocks={[{ items: obj('why.items') }]}
                    />

                    <WhySection
                        title={tp('company.title')}
                        subtitle={tp('company.subtitle')}
                        blocks={[{ items: obj('company.items') }]}
                    />

                    <WhySection
                        title={tp('licenses.title')}
                        blocks={[{ items: obj('licenses.items') }]}
                    />

                    <WhySection
                        title={tp('benefits.title')}
                        blocks={[{ items: obj('benefits.items') }]}
                    />

                    <InfoBlocks
                        title={tp('process.title')}
                        blocks={obj('process.blocks')}
                    />

                    <WhySection
                        title={tp('glance.title')}
                        blocks={[{ items: obj('glance.items') }]}
                    />

                    <FAQList data={obj('faq.items')} title={tp('faq.title')}/>

                    <CTA
                        title={tp('cta.title')}
                        description={tp('cta.description')}
                        buttonText={tp('cta.button')}
                        buttonLink="/quote"
                    />

                </div>
            </section>
        </main>
    );
};
